import React, { useState, useEffect } from "react";
import { getAspekOperasionalAll, getIndikatorKesehatanAll } from "../../api";
import { useSelector } from "react-redux";
import { isBiro } from "../../utils/helper";
import FormFilter from "./formFilter";
import API from "./../../utils/API";
import axiosInstance from "../../api/axiosInstance";
import { toast } from "react-toastify";
import FormField from "./components/FormField";
import { Button } from "semantic-ui-react";
import { createAspekOperasional, findAspekOperasionalByYearAndMonth, updateAspekOperasional } from "../../api";


const AspekOperasional = () => {
  const [data, setData] = useState([]);
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const [rawData, setRawData] = React.useState([]);
  const filter = useSelector((state) => state.filterReducer);
  const [loadingApi, setLoadingApi] = useState(true);
  // const filter = useSelector((state) => state.main);
  const year = useSelector((state) => state.filterDashboard.startYear);
  const month = useSelector((state) => state.filterDashboard.startMonth);
  const perusahaanBumd = useSelector((state) => state.filterDashboard.bumd);
  const perusahaanId = useSelector((state) => state.main.perusahaanFilter);
  const perusahaan = isBiro() ? perusahaanId : user.perusahaan.id;
  const [id, setId] = useState(null);
  const [agregatProyekTahunan, setAgregatProyekTahunan] = useState(0);
  const [apiLoading, setApiLoading] = useState(true);

  const fields = [
    {
      label: "Agregat Proyek",
      value: agregatProyekTahunan,
      onChange: (e) => setAgregatProyekTahunan(e.floatValue),
    },
  ];

  const filterDashboard = useSelector(
    (state) => state.filterDashboard
  );

  const loadData = async () => {
    try {
      if (filterDashboard.bumd !== undefined && isBiro()) {
        var url =
          `/indikator-kesehatan/aspek-operasional?type=${filterDashboard.type}&startMonth=${filterDashboard.startMonth}&endMonth=${filterDashboard.endMonth}&perusahaanId=${filterDashboard.bumd}&startYear=${filterDashboard.startYear}&endYear=${filterDashboard.endYear}`;
      }
      else {
        url =
          `/indikator-kesehatan/aspek-operasional?type=${filterDashboard.type}&startMonth=${filterDashboard.startMonth}&endMonth=${filterDashboard.endMonth}&&perusahaanId=${user.perusahaan.id}&startYear=${filterDashboard.startYear}&endYear=${filterDashboard.endYear}`;
      }
      url = url.trim();
      const r = await API.get(url);
      const d = r.data;
      setData(d);
      setRawData(d);

    } catch (err) {
      toast.error(err.message, { position: toast.POSITION.BOTTOM_RIGHT });
    }
  };

  const getData = async () => {
    try {
      if (isBiro()) {
        var url = `aspek-operasional/filter?year=${filterDashboard.startYear}&perusahaan=${filterDashboard.bumd}&month=${filterDashboard.startMonth}`;
      }
      else {
        url = `aspek-operasional/filter?year=${filterDashboard.startYear}&perusahaan=${user.perusahaan.id}&month=${filterDashboard.startMonth}`;

      }
      // const res = await findAspekOperasionalByYearAndMonth({ year, month, perusahaan });
      url = url.trim();
      const r = await API.get(url);
      if (r.data.length > 0) {
        const data = r.data[0];
        setId(data.id);
        setAgregatProyekTahunan(data.agregatProyekTahunan);

      } else {
        setId(null);
        setAgregatProyekTahunan(0);
      }

    } catch (err) { }
  };

  const handleSubmit = async () => {
    try {
      let data = {
        agregatProyekTahunan,
        year,
        month,
        perusahaan: {
          id: perusahaanBumd,
        },
      };
      if (id !== null) {
        data.id = id;
        await updateAspekOperasional(data);
        toast.info("Data Berhasil Diubah");
      } else {
        await createAspekOperasional(data);
        toast.success("Data Berhasil Disimpan");
      }
      await getData({ year, month, perusahaan, perusahaanBumd });

    } catch (err) { }
  };

  useEffect(() => {
    getData({ year, month, perusahaan, perusahaanBumd });
  }, [year, month, perusahaan, perusahaanBumd]);


  React.useEffect(() => {
    loadData();
  }, [
    filterDashboard
  ]);

  const rowHeaders = [
    "Hasil",
    "Score",
  ];
  return (
    <>
      <FormFilter />
      <div className="container-fluid mt-3">
        <div className="card container shadow-sm border-0">
          {filterDashboard.startMonth == filterDashboard.endMonth && isBiro() && (
            <div className="col-md-8 py-3">
              <hr />
              {fields.map((field, key) => (
                <FormField
                  label={field.label}
                  key={key}
                  value={field.value}
                  onChange={field.onChange}
                  description={field.label}
                />
              ))}
              <hr />
              <Button color="blue" onClick={handleSubmit}>
                Simpan
              </Button>
            </div>
          )}
          <div className="row">
            <div className="col py-3">
              {rawData.length === 0 || filterDashboard.bumd == undefined ? (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center", fontStyle: "italic" }}>
                    Data tidak tersedia
                  </td>
                </tr>
              ) : (
                <table className="table table-responsive table-bordered">
                  <tr>
                    <th></th>
                    {data.map((d) => <>
                      <th colspan="2" style={{ textAlign: "center" }}>{d.year}</th>
                    </>
                    )}
                  </tr>
                  <tr>
                    <th>Penilaian</th>
                    {data.map((d) => <>
                      {rowHeaders.map((header, index) => (
                        <th>{header}</th>
                      ))}
                    </>
                    )}
                  </tr>
                  <tr>
                    <th>Pencapaian Aset (%)</th>
                    {data.map((d) => <>
                      <td style={{ textAlign: "right" }}>{d.hasilPencapaianAset.toString().substring(0, 7)} </td>
                      <td style={{ textAlign: "right" }}>{d.scorePencapaianAset} </td>
                    </>
                    )}
                  </tr>
                  <tr>
                    <th>Pencapaian Pendapatan (%)</th>
                    {data.map((d) => <>

                      <td style={{ textAlign: "right" }}>{d.hasilPencapaianPendapatan} </td>
                      <td style={{ textAlign: "right" }}>{d.scorePencapaianPendapatan} </td>
                    </>
                    )}
                  </tr>
                  <tr>
                    <th>Pencapaian Laba/(Rugi) Bersih (%)</th>
                    {data.map((d) => <>
                      <td style={{ textAlign: "right" }}>{d.hasilPencapaianLaba} </td>
                      <td style={{ textAlign: "right" }}>{d.scorePencapaianLaba} </td>
                    </>
                    )}
                  </tr>
                  <tr>
                    <th>Beban Usaha (Beban Operasional + Penyusutan) (%)</th>
                    {data.map((d) => <>
                      <td style={{ textAlign: "right" }}>{d.hasilBebanUsaha.toString().substring(0, 7)} </td>
                      <td style={{ textAlign: "right" }}>{d.scoreBebanUsaha} </td>
                    </>
                    )}
                  </tr>
                  <tr>
                    <th>Pertumbuhan Aset (%)</th>
                    {data.map((d) => <>
                      <td style={{ textAlign: "right" }}>{d.hasilPertumbuhanAset} </td>
                      <td style={{ textAlign: "right" }}>{d.scorePertumbuhanAset} </td>
                    </>
                    )}
                  </tr>
                  <tr>
                    <th>Pertumbuhan Pendapatan (%)</th>
                    {data.map((d) => <>
                      <td style={{ textAlign: "right" }}>{d.hasilPertumbuhanPendapatan} </td>
                      <td style={{ textAlign: "right" }}>{d.scorePertumbuhanPendapatan} </td>
                    </>
                    )}
                  </tr>
                  <tr>
                    <th>Pertumbuhan Laba/(Rugi) Bersih (%)</th>
                    {data.map((d) => <>
                      <td style={{ textAlign: "right" }}>{d.hasilPertumbuhanLaba} </td>
                      <td style={{ textAlign: "right" }}>{d.scorePertumbuhanLaba} </td>
                    </>
                    )}
                  </tr>
                  <tr>
                    <th>Agregat Proyek Tahunan dan Multiyears (%)</th>
                    {data.map((d) => <>
                      <td style={{ textAlign: "right" }}>{d.hasilAgregatProyek} </td>
                      <td style={{ textAlign: "right" }}>{d.scoreAgregatProyek} </td>
                    </>
                    )}
                  </tr>
                </table>
              )}
              <hr />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AspekOperasional;

